var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomrf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DOMRF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.1749 17.6478H1.60837V15.2956H7.16255V17.6478H7.1749ZM8.29555 14.1133H0.5V20H1.60837V18.8178H8.27095V14.1133H8.29555ZM1.60837 3.53449L3.83744 1.18227V9.4212H1.60837V3.53449ZM0.5 10.5912H4.9335V0H3.28325L0.5 2.94335V10.5912ZM7.1749 1.18227H9.40395V9.4212H7.1749V1.18227ZM6.0665 10.5912H10.5V0H6.0665V10.5912ZM18.271 10.5912H19.3793V0H17.7045V0.0123153L16.0296 1.7734V0H14.3547L11.5961 2.94335V10.5912H12.7044V3.53449L14.9335 1.18227V10.5912H16.0418V3.53449L18.271 1.18227V10.5912ZM0.5 12.9433H19.3916V11.7611H0.5V12.9433ZM14.9458 15.2956H18.271V17.6478H14.9458V15.2956ZM13.8375 17.6478H10.5V15.2956H13.8375V17.6478ZM14.9458 18.8178H19.3916V14.1133H9.40395V18.8178H13.8375V20H14.9458V18.8178Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomrf);
export default __webpack_public_path__ + "static/media/domrf.4b7f08433f976a8452529b94718a5b73.svg";
export { ForwardRef as ReactComponent };